import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import {
  ArrowUpDown,
  Euro,
  Layers3,
  Package,
  Image,
  Users,
  ArrowDownWideNarrow,
  ArrowUpWideNarrow,
  PinIcon,
  Phone,
} from "lucide-react";

import React from "react";

const columnHelper = createColumnHelper();

const columns = [
  columnHelper.accessor("shop", {
    cell: (info) => {
      // @ts-ignore
      const value = info.getValue().name || "";
      // @ts-ignore
      const displayValue = value
        ? // @ts-ignore
          value?.substring(0, 35).toLocaleLowerCase()
        : "";
      const tooltipValue = value ? value : "";
      // @ts-ignore
      const showEllipsis = value.length > 35;
      return (
        <a
          href={`/shop/${
            //@ts-ignore
            info.getValue().id
          }`}
          className="tooltip text-xs text-center cursor-pointer"
        >
          {displayValue} {showEllipsis ? "..." : ""}
          <span className="tooltiptext">{tooltipValue}</span>
        </a>
      );
    },
    header: () => (
      <span className="flex items-center justify-center">
        <Package className="mr-2" size={16} /> Nom
      </span>
    ),
  }),
  columnHelper.accessor("city", {
    id: "city",
    cell: (info) => (
      <span className="italic text-center text-blue-600">
        {info.getValue()}
      </span>
    ),
    header: () => (
      <span className="flex items-center">
        <PinIcon className="mr-2" size={16} /> Ville
      </span>
    ),
  }),
  columnHelper.accessor("phone", {
    id: "phone",
    cell: (info) => (
      <span className="italic text-center text-blue-600">
        {info.getValue()}
      </span>
    ),
    header: () => (
      <span className="flex items-center">
        <Phone className="mr-2" size={16} /> Téléphone
      </span>
    ),
  }),
  columnHelper.accessor("membersCount", {
    header: () => (
      <span className="flex items-center">
        <Users className="mr-2" size={16} /> Salariés
      </span>
    ),
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("adsCount", {
    header: () => (
      <span className="flex items-center">
        <Layers3 className="mr-2" size={16} /> Annonces
      </span>
    ),
    cell: (info) => info.getValue(),
  }),
];

export const ShopsTable = ({ iData: data }) => {
  // const [data] = React.useState(() => [...iData]);
  const [sorting, setSorting] = React.useState([]);
  const [globalFilter, setGlobalFilter] = React.useState("");
  const skipPageResetRef = React.useRef();

  // React.useEffect(() => {
  //   // After the table has updated, always remove the flag
  //   skipPageResetRef.current = false;
  // });

  const table = useReactTable({
    data,
    // @ts-ignore
    columns,
    state: {
      sorting,
      globalFilter,
    },
    initialState: {
      pagination: {
        pageSize: 5,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    // @ts-ignore
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),

    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    // re render the component when the data changes
    // forceUpdate((prev) => !prev),
    // autoResetPageIndex: !skipPageResetRef.current,
    // autoResetExpanded: !skipPageResetRef.current,
  });

  return (
    <div className="flex flex-col mx-auto py-2 sm:px-6 lg:px-2">
      <div className="overflow-x-auto bg-white rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="px-6 py-3 text-center text-xs font-medium text-gray-500 tracking-wider"
                  >
                    <div
                      {...{
                        className: header.column.getCanSort()
                          ? "cursor-pointer select-none flex items-center justify-center"
                          : "",
                        onClick: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      {header.column.getIsSorted() ? (
                        <span>
                          {header.column.getIsSorted() === "desc" ? (
                            <ArrowDownWideNarrow size={14} className="ml-2" />
                          ) : (
                            <ArrowUpWideNarrow size={14} className="ml-2" />
                          )}
                        </span>
                      ) : (
                        <ArrowUpDown className="ml-2" size={14} />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="hover:bg-gray-50">
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="px-2 py-1 whitespace-nowrap text-xs text-gray-500 text-center"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
